import React from 'react';
import IconAppStore from '../../../static/icons/_inline-svg/our-app/icon_app_store.svg';
import IconGooglePlay from '../../../static/icons/_inline-svg/our-app/icon_google_play.svg';
import OurAppImage1 from '../../../static/images/cards/our-app/2.png';
import OurAppImage2 from '../../../static/images/cards/our-app/3.png';
import OurAppImage3 from '../../../static/images/cards/our-app/1.png';
import ExternalUrls from '../../data/ExternalUrls';
import DownloadButton from './_shared/buttons/DownloadButton';

const OurAppCard = () => {
    return (
        <div className="card flex flex-col lg:flex-row space-y-10 lg:space-x-10 lg:space-y-0 justify-between overflow-hidden">
            <div className="flex flex-col lg:w-1/2 xl:w-5/12">
                <h1 className="card-title">Connect with your fans 📱</h1>
                <span className="mt-4 text-card-text-color xl:w-10/12">
                    {/* Here they can have access to the Sports Teams and players
                    info, get notifications about club and sponsor activations,
                    take advantage of all AR Experiences and even have an access
                    point to the My Jersey Collection. */}
                    In addition to our AR Experiences and the MyJersey collection display, 
                    fans will have exclusive access to teams and players information. 
                    Thanks to notifications they won't miss the latest news and will 
                    always be up to date with the latest information about club and 
                    sponsors activations. 
                </span>

                <div className="download-app-links flex flex-col space-y-6 xl:w-4/6 pt-6 mt-auto">
                    <DownloadButton
                        text="Download on App Store"
                        icon={<IconAppStore />}
                        url={ExternalUrls.appStore}
                    />
                    <DownloadButton
                        text="Download on Google Play"
                        icon={<IconGooglePlay />}
                        url={ExternalUrls.googlePlay}
                    />
                </div>
            </div>
            <div className="flex justify-center items-center space-x-4 lg:w-1/2 xl:w-7/12 1xl:space-x-10">
                <img
                    src={OurAppImage1}
                    alt=""
                    className="mobile-frame-img"
                />
                <img
                    src={OurAppImage2}
                    alt=""
                    className="mobile-frame-img"
                />
                <img
                    src={OurAppImage3}
                    alt=""
                    className="mobile-frame-img"
                />
            </div>
        </div>
    );
};

export default OurAppCard;
